import {
  Container,
  LoadingContainer,
  LoadedIndicator,
  MoneyTextMask,
  InfoText
} from './styles'

export default function LoadingBar ({
  currentValue,
  totalValue,
  valueUnit = '',
  showValue = true,
  width = 120,
  height = 7,
  color = null,
  direction = 'row',
  textMask = 'number',
  textStyle = {}
}) {
  return (
    <Container direction={direction}>
      <LoadingContainer width={width} height={height}>
        <LoadedIndicator
          height={height}
          currentValue={currentValue}
          totalValue={totalValue}
          color={color}
        />
      </LoadingContainer>
      {showValue && (
        textMask === 'currency' ? (
          <InfoText style={textStyle}>
            <MoneyTextMask style={textStyle} value={currentValue}/>
            {' / '}
            <MoneyTextMask style={textStyle} value={totalValue}/>
          </InfoText>
        ) : (
          <InfoText style={textStyle}>
            {currentValue} / {totalValue} {valueUnit}
          </InfoText>
        )
      )}
    </Container>
  )
}
